module.exports = __webpack_public_path__ + "img/honor_005.9b5b204.webp";